export const iconFontAwesomeScienceBrain = (
	<i className="fa-solid fa-brain"></i>
);
